import Landlord from "pages/LandLord";
import LandlordApplicationSuccess from "pages/LandLord/LandlordApplicationSuccess";
import React from "react";
import { Route } from "react-router-dom";


export const TENANT_APPLICATION_COMPLETED = "/tenant/application/submitted";
export const TENANT_APPLICATION_STAGE_TWO = "/tenant/:tenantId/:applicationId";
export const LANDLORD_APPLICATION_COMPLETED = "/landlord/application-approved";
/**
 * An array of route configuration objects for tenant-related routes.
 *
 * Each object in the array specifies the `path` for the route and the corresponding
 * React component to render when the route is matched.
 *
 * @example
 * // Access the first route's path
 * const firstRoutePath = TENANT_ROUTE_LISTS[0].path;
 *
 * @remarks
 * This list is intended to be used for setting up routing in the tenant section of the application.
 */
const LANDLORD_ROUTE_LISTS = [
    {
        path: LANDLORD_APPLICATION_COMPLETED,
        component: LandlordApplicationSuccess
    },
    {
        path: "/landlord/:landlordId",
        component: Landlord
    }
];



/**
 * Generates a list of `<Route>` elements for tenant-specific routes.
 *
 * Iterates over `TENANT_ROUTE_LISTS`, mapping each route configuration to a React Router `<Route>` component.
 * Each route object should contain a `path` and a `component` property.
 *
 * @remarks
 * The `key` prop for each `<Route>` is set to the route's path or its index as a fallback.
 * The `element` prop renders the corresponding route component.
 *
 * @example
 * ```tsx
 * <Routes>
 *   {tenantRoutesList}
 * </Routes>
 * ```
 */
export const landlordRoutes = LANDLORD_ROUTE_LISTS.map(
    (route: { path: string; component: React.ComponentType }, idx: number) => (
        <Route
            key={route.path || idx}
            path={route.path}
            element={<route.component />}
        />
    )
);